export default __webpack_public_path__ + "static/media/github-background-light.7fa45dda.svg";